import { RefObject } from 'react';

import { useOutsideClick, UseOutsideClickParams } from 'utils/hooks/use-outside-click';

type OutsideClickProps = Omit<UseOutsideClickParams, 'ref'> & {
    /** the element(s) that count as inside (a prop cannot be named ref) */
    elementRef: RefObject<HTMLElement | null> | ReadonlyArray<RefObject<HTMLElement | null>>;
};

/**
 * useOutsideClick for a class component, where a hook cannot be called: render it next to the element; it renders
 * nothing. A function component calls the hook itself.
 */
const OutsideClick = ({
    elementRef,
    callback,
    isEnabled,
    closeOnScroll,
    closeOnTouchStart,
    capture
}: OutsideClickProps) => {
    useOutsideClick({ ref: elementRef, callback, isEnabled, closeOnScroll, closeOnTouchStart, capture });

    return null;
};

export default OutsideClick;
